import React from 'react';
import { BRAND, PRODUCT_NAME, SUPPORT_EMAIL } from '../data/salesContent';
export function SiteFooter() {
  return <footer className="border-t border-zinc-800 bg-zinc-950 px-5 py-10 text-center md:px-12" data-id="element-223" data-mp="3r9aote3xlhyo">
      <p className="font-display text-lg font-extrabold uppercase tracking-[0.2em] text-cyan-400" data-id="element-224" data-mp="3mgrfitca18zo">{BRAND}</p>
      <p className="mt-3 text-sm text-zinc-400" data-id="element-225" data-mp="3hhenlu6jtbq8">
        © 2026 {BRAND} · {PRODUCT_NAME} · Todos los derechos reservados.
      </p>
      <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-zinc-500" data-id="element-226" data-mp="3derttnqbhgqe">
        {PRODUCT_NAME} es un recurso educativo y de consulta general. No reemplaza el manual del fabricante, especificaciones
        particulares del vehículo, procedimientos de seguridad, diagnóstico profesional ni la intervención de personal capacitado
        cuando corresponda.
      </p>
      <nav aria-label="Enlaces legales" className="mt-5 text-sm text-zinc-400" data-id="element-227" data-mp="11q0jrv7vm6hc">
        <span data-id="element-228" data-mp="wta7zk33tx1q">Términos y condiciones</span>
        <span className="mx-2 text-zinc-600" aria-hidden="true" data-id="element-229" data-mp="wq4gjy706j2u">·</span>
        <span data-id="element-230" data-mp="15q2cctzwpebu">Política de privacidad</span>
        <span className="mx-2 text-zinc-600" aria-hidden="true" data-id="element-231" data-mp="1apyesosygxpa">·</span>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline-offset-4 transition-colors duration-150 hover:text-cyan-400 hover:underline" data-id="element-232" data-mp="1ar9k4t21udii">
          Contacto
        </a>
      </nav>
      <p className="mt-4 text-sm text-zinc-400" data-id="element-233" data-mp="10sajnxrfto6l">
        Soporte:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-cyan-400 underline-offset-4 hover:underline" data-id="element-234" data-mp="1oh35v2i9cho0">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}